let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bfdhs")).then(() => parcelRequire('973sf'));